// extracted by mini-css-extract-plugin
module.exports = {"root":"WorkLogList_root__3vkR5","listWrap":"WorkLogList_listWrap__21RZ5","workLogList":"WorkLogList_workLogList__Bozn4"};